import React from 'react';
/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  a,
  gs,
  ls,
  useMsgz,
  useLdrz,
  useCfmz,
  cmFTH,
//  BarC,
  BoxC,
  BtnC,
  CbxC,
  IptC,
  LblC,
  MsgC,
  SrlC,
  TextC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";
import { useMsgz } from "./_csMdlMsg";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as icm from './icm';
import * as ihd from './ihd';

import * as icvI10___Mz from './icvI10___Mz';
import * as icvI17___Tz from './icvI17___Tz';
import * as icvI17___Mz from './icvI17___Mz';
import * as icvI18___Mz from './icvI18___Mz';
import * as icvI1z___Mz from './icvI1z___Mz';

import * as icvI1z___TzAby from './icvI1z___TzAby';

//import * as spl from './sample';

//let $yearMth = _hmDTM.f(hfDTM.getTdy(), 'YYYY-MM');

const $grtDateEnd = (date: _ht.s) => _hmDTM.addDay(_hmDTM.addMth($dateStt, 1), -1);

let $i10rs = [] as _ht.ls;
let $i10rz = {} as _ht.dz;
let $i17rs = [] as _ht.ls;
let $i18rs = [] as _ht.ls;
let $i18rz = {} as _ht.dz;
let $i1zz = icvI1z___Mz.crtI1zz({
  i1zrz: {
    i1zrs1100i: 80, 
  },
  i1z3z: {
    i1z3t3100i: -1, // 支払方法
  }
});
let $dateStt = _hmDTM.getTdy();
let $dateEnd = $grtDateEnd($dateStt);

const $ilz = () => { // 初期化
  $i1zz = icvI1z___Mz.crtI1zz();
  $i10rz = {};
  $i18rz = {};
  $dateStt = _hmDTM.getTdy();
};

export const N = (pz: {
  sPz: _ht.dz,
  pagez: _ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  const _udtThis = ls.udtThis();

  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();
  const _sCfmz = useCfmz();

//$i10rs = pz.pagez.i10rs;
//$i17rs = pz.pagez.i17rs;
  React.useEffect(() => {
    cmFTH.loadAllAsync({
      frcUdt: _udtThis,
      bfrAsync: () => [
        icvI10___Mz.loadI10rLsAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
        })
        .then((_ls: _ht.ls) => {
          $i10rs = _ls;
        }),
        icvI17___Mz.loadI17rLsAsync({
          _31r_fst: _gUserz.crt._31rz._fst,
        })
        .then((_ls: _ht.ls) => {
          $i17rs = _ls;
        }),
        icvI18___Mz.loadI18rLsAsync()
        .then((_ls: _ht.ls) => {
          $i18rs = _ls;
        }),
      ]
    })
  }, []);


  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -10,
              abtType: 'cttCmnz',
/*
              srlStlz: {
                otrz: a('dw/f dwx/120 f/1'),
                inrz: a('fd/csc'),
              },
*/
              oClds: [

                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'rmkCmnz',
                  boxStlz: a(`dw/f fd/rsc mb/1`),
                  textz: {
                    pfx: '※：必須',
                  }
                }),

                cr.c(GridC.N, {
                  key: -20,
                  abtType: 'nolineCmnz',
                  boxStlz: a(`mb/2`),
                  lineCs: [
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                textz: {
                                  pfx: '部屋：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'pcr',
                                      ls: $i10rs,
                                      vle: $i10rz._fst,
                                      onChg: (_dz: _ht.dz) => {
                                        $i10rz = _dz;
                                        $i1zz.i1z1s = [];
                                        _udtThis();
                                      }
                                    }
                                  })
                                ],
                              },
                              omtCz: 
                                {
                                  abtType: 'omtRqrCmnz',
                                }
                            }),
                          ]
                        },
                        {
                          oClds: [
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                textz: {
                                  pfx: '利用期間：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'dtm',
                                      vle: $dateStt,
                                      onChg: (_s: _ht.s) => {
                                        $dateStt = _s;
                                        $dateEnd = $grtDateEnd(_s);
                                        $i1zz.i1z1s = [];
                                        _udtThis();
                                      }
                                    }
                                  }),
                                  cr.c(TextC.N, {
                                    key: -20,
                                    boxStlz: a(`dw/4`),
                                    textz: {
                                      pfx: ` 〜 `,
                                    }
                                  }),
                                  cr.c(IptC.S, {
                                    key: -30,
                                    cz: {
                                      bEdit: false,
                                      iptType: 'text',
                                      vle: $dateEnd,
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                        {
                          oClds: [
                          ]
                        },
                      ]
                    },
                  ]
                }),

                $i10rz._fst > 0 ?
                cr.c(BoxC.N, {
                  key: -30,
                  boxStlz: a('dw/f mb/3 mt/1 p/1 sc/lm1'),
                  oClds: [
                    cr.c(icvI1z___TzAby.V3, {
                      key: -30,
                      sPz: pz.sPz,
                      frcUdt: _udtThis,
                      cz: {
                        bEdit: true,
                        bNext: false,
                        dates: _hmDTM.grtDates($dateStt, $dateEnd),
                        i10r_fsts: [$i10rz._fst],
                        i1zz: $i1zz,
                        _31r_fst: _gUserz.crt._31rz._fst,
                        bMplDay: true,
                        bChkAll: true,
                      },
                    })
                  ]
                })
                : undefined,

                cr.c(GridC.N, {
                  key: -40,
                  abtType: 'nolineCmnz',
                  boxStlz: a(`mb/3`),
                  lineCs: [
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                textz: {
                                  pfx: '団体：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
//                                      iptType: 'pcr',
                                      iptType: 'sch',
                                      ls: $i18rs,
  //                                    vle: spl.rsvz['団体'],
                                      vle: $i18rz._fst,
                                      onChg: (_dz: _ht.dz) => {
                                        $i1zz.i1zrz.i1zri18r1f = _dz.key;
                                        $i18rz = _dz;
                                        icm.udtI1zzFromI18rz({
                                          i1zz: $i1zz,
                                          i18rz: $i18rz,
                                        });
                                        icm.udtI1z3z({
                                          i1zz: $i1zz,
                                          i17rs: $i17rs,
                                        });
                                        _udtThis();
                                      }
                                    }
                                  })
                                ],
                              },
                              omtCz: 
                                {
                                  abtType: 'omtRqrCmnz',
                                }
                            }),
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                textz: {
                                  pfx: '団体番号：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: false,
                                      iptType: 'text',
//                                      vle: spl.rsvz['代表者'],
                                      vle: $i18rz.i18rab100s ?? '−',
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                textz: {
                                  pfx: '団体登録日：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: false,
                                      iptType: 'text',
                                      vle: String($i18rz?.createdAt ?? '').substring(0, 10),
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/3`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                textz: {
                                  pfx: '代表者：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: false,
                                      iptType: 'text',
//                                      vle: spl.rsvz['代表者'],
                                      vle: $i18rz.i18ra2110s ?? '−',
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                textz: {
                                  pfx: '利用制限：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: false,
                                      iptType: 'pcr',
                                      ls: ihd.f('i18rt1100i').ls,
                                      vle: $i18rz.i18rt1100i ?? `−`,
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                boxStlz: a('dw/18'),
                                textz: {
                                  pfx: '申込者：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $i1zz.i1zrz.i1zra2100s,
                                      onChg: (_s: _ht.s) => {
                                        $i1zz.i1zrz.i1zra2100s = _s;
                                      }
                                    }
                                  })
                                ],
                              },
                              omtCz: 
                                {
                                  abtType: 'omtRqrCmnz',
                                }
                            }),
                          ]
                        },
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                textz: {
                                  pfx: '登録日：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'dtm',
                                      vle: $i1zz.i1zrz.i1zrd1100s,
                                      onChg: (_s: _ht.s) => {
                                        $i1zz.i1zrz.i1zrd1100s = _s;
                                      }
                                    }
                                  })
                                ],
                              },
                              omtCz: 
                                {
                                  abtType: 'omtRqrCmnz',
                                }
                            }),
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/3`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                boxStlz: a('dw/18'),
                                textz: {
                                  pfx: '連絡先電話番号：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $i1zz.i1zrz.i1zra3100s,
                                      onChg: (_s: _ht.s) => {
                                        $i1zz.i1zrz.i1zra3100s = _s;
                                      }
                                    }
                                  })
                                ],
                              },
                              omtCz: 
                                {
                                  abtType: 'omtRqrCmnz',
                                }
                            }),
                          ]
                        },
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                textz: {
                                  pfx: '申込日：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'dtm',
                                      vle: $i1zz.i1zrz.i1zrd2100s,
                                      onChg: (_s: _ht.s) => {
                                        $i1zz.i1zrz.i1zrd2100s = _s;
                                      }
                                    }
                                  })
                                ],
                              },
                              omtCz: 
                                {
                                  abtType: 'omtRqrCmnz',
                                }
                            }),
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/3`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                boxStlz: a(`dw/12`),
                                textz: {
                                  pfx: '予約状況：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(CbxC.MS, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      ls: [
                                        { key: 80, pfx: '仮予約' },
                                        { key: 90, pfx: '本予約' },
                                      ],
                                      vle: $i1zz.i1zrz.i1zrs1100i, // 仮押は仮予約として表示
                                      onChg: (_key: _ht.n) => {
//_hm.l(`icvI1zS12Co 622a: ${_key}, ${_hm.s($i1zz)}`);
                                        icm.udtI1zrs1100i({
                                          i1zz: $i1zz, 
                                          i1zrs1100i: _key
                                        });
//_hm.l(`icvI1zS12Co 622b: ${_key}, ${_hm.s($i1zz.i1zrz.i1zrs1100i)}, ${_hm.s($i1zz)}`);
                                        _udtThis();
                                      }
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                boxStlz: a('dw/10'),
                                textz: {
                                  pfx: '受領日：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'dtm',
                                      vle: $i1zz?.i1z3z.i1z3d2100s,
                                      onChg: ( _s: _ht.s ) => {
                                        $i1zz.i1z3z.i1z3d2100s = _s;
                                        if ( $i1zz?.i1z3z.i1z3s1100i == 40 ) {
                                          $i1zz.i1zrz.i1zrs1100i = 90;
                                          _udtThis();
                                        }
                                      }
                                    }
                                  })

                                ],
                              }
                            }),
                          ]
                        },
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                abtType: 'hzlStfz',
                                boxStlz: a('dw/12'),
                                textz: {
                                  pfx: '支払方法：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'pcr',
                                      ls: ihd.f('i1z3t3100i').ls,
                                      vle: $i1zz?.i1z3z.i1z3t3100i,
                                      onChg: ( _dz: _ht.dz ) => {
                                        $i1zz.i1z3z.i1z3t3100i = _dz.key;
                                      }
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`dh/8 f/2 mb/3`),
                      cellCs: [
                        {
                          boxStlz: a(`fd/ccc`),
                          oClds: [
                            cr.c(CbxC.SS, {
                              key: -20,
                              boxStlz: a(`bc/gn7 bw/1 ph/4 pv/2`),
                              cz: {
                                bEdit: true,
                                vle: $i1zz?.i1zrz.i1zrt1100i,
                                onChg: ( _n: _ht.n ) => {
                                  $i1zz.i1zrz.i1zrt1100i = _n;
                                },
                              },
                              lblCz: {
                                textz: {
                                  pfx: '優先利用',
                                  stlz: a(`tb tc/gn7`),
                                }
                              }
                            })

                          ]
                        },
                        {
                          boxStlz: a(`f/2 fd/css`),
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              boxStlz: a(`mb/1`),
                              lblCz: {
                                abtType: 'hzlStfz',
                                textz: {
                                  pfx: '目的：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $i1zz.i1zrz.i1zra4100s,
                                      onChg: (_s: _ht.s) => {
                                        $i1zz.i1zrz.i1zra4100s = _s;
                                      }
                                    }
                                  })
                                ],
                              },
                              omtCz: 
                                {
                                  abtType: 'omtRqrCmnz',
                                }
                            }),
                            cr.c(LblC.N, {
                              key: -20,
                              abtType: 'hzlStfz',
                              boxStlz: a(`mb/1`),
                              lblCz: {
                                abtType: 'hzlStfz',
                                textz: {
                                  pfx: '備考：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $i1zz.i1zrz._ctn,
                                      onChg: (_s: _ht.s) => {
                                        $i1zz.i1zrz._ctn = _s;
                                      }
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: 'hzlStfz',
                              lblCz: {
                                textz: {
                                  pfx: '内部メモ：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $i1zz.i1zrz.i1zra5100s,
                                      onChg: (_s: _ht.s) => {
                                        $i1zz.i1zrz.i1zra5100s = _s;
                                      }
                                    }
                                  })
                                ],
                              }
                            }),
                          ]
                        },
                      ]
                    },
                  ]
                }),

                _gUserz.crt.i19rz.i19ra2210i == 1 ? 
                cr.c(icvI17___Tz.T, {
                  key: -50,
                  sPz: pz.sPz,
                  boxStlz: a(`dw/60 mh/a`),
                  cz: {
                    bEdit: true,
                    bFee: false,
                    i1zz: $i1zz,
                    _31r_fst: _gUserz.crt._31rz._fst,
                    clr: pz.sPz.crt.dffz.clr,
                    bMplDay: true,
                  }
                })
                : undefined,

              ],
            }),

            cr.c(GridC.N, {
              key: -40,
              abtType: 'barBtnViewCmnz',
              lineCs: [{
                cellCs: [
                  {
                    oClds: [
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'backCmnz',
                        lblCz: {
                          textz: {
                            pfx: '前の画面に戻る',
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            pz.sPz.set({
                              steps: [0],
                            })
                          }
                        },
                      }),
                    ]
                  },
                  {
                    oClds: [
                      cr.c(BtnC.N, {
                        key: -20,
                        abtType: 'nextCmnz',
                        lblCz: {
                          textz: {
                            pfx: 'この内容で予約を一括登録',
                          },
                        },
                        pslPtyz: {
                          onPress:
                            async () => {
                              await icm.saveI1zzAsync2({
                                i1zz: $i1zz,
                                i10rs: pz.pagez?.i10rs,
                                i17rs: pz.pagez?.i17rs,
                                i15rs: pz.pagez?.i15rs,
                                i18rz: $i18rz,
                                hdys: pz.pagez?.hdys,
                                sMsgz: _sMsgz,
                                sLdrz: _sLdrz,
                                sCfmz: _sCfmz,
                                atrAsync: () => {
                                  $ilz();
                                  pz.sPz.set({
                                    steps: [0],
                                  })
                                }
                              })
                            }
                        },
                      }),
                    ]
                  }
                ]
              }]
            })

          ]
        })

      ]
    })
  );
};
